import React from 'react'
import {Helmet} from 'react-helmet'

import '../styles/descripcion-imagenes.css'

import {
    Row,
    Col,
} from 'antd'
import Layout from  '../components/layout'
import MapaLotes from '../components/lotes/MapaLotes'
import MapaLotesMacrolotes from '../components/lotes/MapaLotesMacrolotes'
import MapaLotesLosRiscos from '../components/lotes/MapaLotesLosRiscos'
import FormularioContacto from '../components/formulario'
import ProjectoSlider from '../components/carrusel/ProjectoSlider'

const Proyectos = ({ pageContext }) => {
  const {name, descripcion, imagenProyecto, images, bloqueUno, bloqueDos, mapa, enlace, titulo, logo, english} = pageContext
  
  return (
    <Layout english={english}>
        <Helmet defer={false}>
            <meta charSet="utf-8" />
            <title>{titulo}</title>
            <meta name="description" content={descripcion} />
        </Helmet>
        <div style={{position : 'relative'}}>
            <img 
                className="imagen-proyecto" 
                src={imagenProyecto}
                alt={name}
            />
            <div className="descripcion descripcion-izquierda">
                <p className="texto-descripcion">
                    {descripcion}
                </p>
                <h1 className="titulo-descripcion">
                    {titulo}
                </h1>
            </div>
        </div>
        <div >
            <Row align="middle" justify="center" style={{paddingTop: 15, paddingBottom: 25}}> 
                <Col xs={22} md={12} className="texto-superior">
                    <Row justify="center" align="center" style={{paddingBottom: 25}}>
                        {logo 
                            ?
                                <a href={enlace} target="_blank" rel="noreferrer">
                                    <img src={logo} alt={titulo}/>
                                </a>
                            :
                                <h2 className="titulo">{name}</h2>
                        
                        }
                    </Row>
                    <Row justify="start" className="contenedor-bloques">
                        {bloqueUno.map((texto, index) => (
                            <p key={index} className="texto-proyecto">
                                {texto}
                            </p>
                        ))}
                    </Row>
                </Col>
                <Col xs={24} md={12}>
                    <ProjectoSlider imgs={images} />
                </Col>
            </Row>
        </div>
        {(name === "Macrolotes" || name === "MACRO LOTS")
            ? <MapaLotesMacrolotes english={english} /> :
            (name === "Los Riscos" || name === "Los Riscos") ?
            <MapaLotesLosRiscos textos={bloqueDos} mapa={mapa} enlace={enlace} english={english} /> :
            <MapaLotes textos={bloqueDos} mapa={mapa} enlace={enlace} english={english} />
        }
        <FormularioContacto english={english} />
    </Layout>
    )
  
}

export default Proyectos